export default {
  action_plan: 'Plano de ação',
  // Date Time
  month: 'mês',
  month_plural: 'meses',
  day: 'dia',
  day_plural: 'dias',
  hour: 'hora',
  hour_plural: 'horas',
  minute: 'minuto',
  minute_plural: 'minutos',

  // Profiles
  'profiles.owner': 'Proprietário',
  'profiles.thirdParty': 'Terceiro',
  'profiles.thirdPartyUser': 'Usuário de Terceiro',
  'profiles.user': 'Usuário',
  'profiles.administrator': 'Administrador',
  'profiles.administrative': 'Administrativo',

  // Filters
  'filter.typeIds': '{{count}} tipos',
  'filter.typeIds_plural': '{{count}} tipos',
  'filter.groupIds': '{{count}} grupo',
  'filter.groupIds_plural': '{{count}} grupos',
  'filter.profileIds': '{{count}} perfil',
  'filter.profileIds_plural': '{{count}} perfis',
  'filter.entityCompanId': '{{count}} projeto',
  'filter.entityCompanId_plural': '{{count}} projetos',
  'filter.checkList': '{{count}} questionário',
  'filter.checkListIds': '{{count}} questionário',
  'filter.checkList_plural': '{{count}} questionários',
  'filter.checkListIds_plural': '{{count}} questionários',
  'filter.serviceId_plural': '{{count}} questionários',
  'filter.entityChecklistIds': '{{count}} questionário',
  'filter.entityChecklistIds_plural': '{{count}} questionários',
  'filter.checkLists': '{{count}} questionário',
  'filter.checklistIds': '{{count}} questionário',
  'filter.checkLists_plural': '{{count}} questionários',
  'filter.checklistIds_plural': '{{count}} questionários',
  'filter.checklist': '{{count}} questionário',
  'filter.checklist_plural': '{{count}} questionários',
  'filter.service': '{{count}} questionário',
  'filter.service_plural': '{{count}} questionários',
  'filter.questions': '{{count}} pergunta',
  'filter.questions_plural': '{{count}} perguntas',
  'filter.questionIds': '{{count}} pergunta',
  'filter.questionIds_plural': '{{count}} perguntas',
  'filter.serviceType.id': '{{count}} tipo de questionário',
  'filter.serviceType.id_plural': '{{count}} tipos de questionário',
  'filter.placeLevel': '{{count}} selecionado',
  'filter.placeLevel_plural': '{{count}} selecionados',
  'filter.placeLevels': '{{count}} nivel de local/pessoa',
  'filter.placeLevels_plural': '{{count}} niveis de locais/pessoas',
  'filter.placeLevelIds': '{{count}} selecionado',
  'filter.placeLevelIds_plural': '{{count}} selecionados',
  'filter.places': '{{count}} local/pessoa',
  'filter.places_plural': '{{count}} locais/pessoas',
  'filter.placeIds': '{{count}} local/pessoa',
  'filter.placeIds_plural': '{{count}} locais/pessoas',
  'filter.placeId_plural': '{{count}} locais/pessoas',
  'filter.entityPlaceIds': '{{count}} local/pessoa',
  'filter.entityPlaceIds_plural': '{{count}} locais/pessoas',
  'filter.place': '{{count}} local/pessoa',
  'filter.place_plural': '{{count}} locais/pessoas',
  'filter.statusNames': '{{count}} status',
  'filter.statusIds_plural': '{{count}} status',
  'filter.userIds': '{{count}} usuário',
  'filter.userIds_plural': '{{count}} usuários',
  'filter.assetIds': '{{count}} ativo',
  'filter.assetIds_plural': '{{count}} ativos',
  'filter.semaphoreKeys': '{{count}} farol',
  'filter.semaphoreKeys_plural': '{{count}} farois',
  'filter.userId_plural': '{{count}} usuários',
  'filter.user': '{{count}} usuário',
  'filter.users_plural': '{{count}} usuários',
  'filter.entityUserIds': '{{count}} usuário',
  'filter.createdByIds': 'Criado por {{count}} usuário',
  'filter.createdByIds_plural': 'Criado por {{count}} usuários',
  'filter.entityUserIds_plural': '{{count}} usuários',
  'filter.group.id': '{{count}} grupo',
  'filter.group.id_plural': '{{count}} grupos',
  'filter.role.id': '{{count}} perfil',
  'filter.role.id_plural': '{{count}} perfis',
  'filter.servieOrder': '{{count}} atividade',
  'filter.servieOrder_plural': '{{count}} atividades',
  'filter.entityServiceOrderIds': '{{count}} atividade',
  'filter.entityServiceOrderIds_plural': '{{count}} atividades',
  'filter.servieOrder.id': '{{count}} atividade',
  'filter.servieOrder.id_plural': '{{count}} atividades',
  'filter.refundType.id': '{{count}} tipo de reembolso',
  'filter.refundType.id_plural': '{{count}} tipos de reembolso',
  'filter.levels': '{{count}} levels',
  'filter.origins': '{{count}} origens',

  // Entities
  'entity.asset': 'Ativo',
  'entity.formReply': 'Respostas de formulário',
  'entity.serviceOrder': 'Atividade',
  'entity.serviceOrder_plural': 'Atividades',
  'entity.user': 'Usuários',
  'entity.service': 'Questionários',
  'entity.checkList': 'Questionários',
  'entity.checklist': 'Questionários',
  'entity.refund': 'Reembolsos',
  'entity.person': 'Pessoas',
  'entity.fleet': 'Frotas',
  'entity.location': 'Locais',
  'entity.form': 'Formulário',
  'entity.actionPlan': 'Plano de ação',

  // Field types
  'fieldTypes.action_plan': 'Plano de ação',
  'fieldTypes.block': 'Bloco',
  'fieldTypes.asset': 'Ativo',
  'fieldTypes.user': 'Usuário',
  'fieldTypes.checkbox': 'Sim ou Não',
  'fieldTypes.compliance': 'Conformidade',
  'fieldTypes.cpf_cnpj': 'Documento',
  'fieldTypes.gallery': 'Anexos',
  'fieldTypes.location': 'Endereço',
  'fieldTypes.numeric': 'Numérico',
  'fieldTypes.multiple': 'Múltipla escolha',
  'fieldTypes.stock': 'Estoque',
  'fieldTypes.pending': 'Pendência',
  'fieldTypes.select': 'Seleção única',
  'fieldTypes.sign': 'Assinatura',
  'fieldTypes.signature': 'Assinatura (perfil)',
  'fieldTypes.system_status': 'Status do sistema',
  'fieldTypes.address': 'Endereço',
  'fieldTypes.integer': 'Número',
  'fieldTypes.number': 'Número',
  'fieldTypes.float': 'Decimal',
  'fieldTypes.text': 'Texto',
  'fieldTypes.date': 'Data',
  'fieldTypes.time': 'Hora',
  'fieldTypes.datetime': 'Data e Hora',
  'fieldTypes.email': 'Email',
  'fieldTypes.picture': 'Imagem',
  'fieldTypes.file': 'Arquivo',
  'fieldTypes.phoneNumber': 'Telefone',
  'fieldTypes.place': 'Local',
  'fieldTypes.place_location': 'Locais',
  'fieldTypes.place_person': 'Pessoas',
  'fieldTypes.place_fleet': 'Frota',
  'fieldTypes.tags': 'Tags',
  'fieldTypes.assets': 'Ativos',
  'fieldTypes.informative': 'Informativa',
  'fieldTypes.calc': 'Cálculo',
  'fieldTypes.integration': 'Integração',
  'fieldTypes.coordinates': 'Coordenadas',
  'fieldTypes.validation_code': 'Código de validação',

  // Field types descriptions for tooltips
  'fieldTypes.action_plan.description': 'Campo para criar planos de ação e acompanhar pendências.',
  'fieldTypes.block.description': 'Agrupa perguntas em formato de tabela para itens do tema.',
  'fieldTypes.asset.description': 'Seleção de item cadastrado para rastreamento de recursos.',
  'fieldTypes.checkbox.description':
    'Duas opções fixas pré-definidas e editáveis (Conforme/Não Conforme). *Contém lógica.',
  'fieldTypes.date.description': 'Campos de formato data e horário para seleção.',
  'fieldTypes.datetime.description': 'Campos de formato data e horário para seleção.',
  'fieldTypes.time.description': 'Campo para seleção de hora.',
  'fieldTypes.gallery.description': 'Anexe fotos ou arquivos .docx, .xlsx, .pptx e PDF.',
  'fieldTypes.pending.description': 'Campo para registrar pendências e acompanhamento.',
  'fieldTypes.multiple.description': 'Selecione uma ou várias opções da lista pré-definida. *Contém lógica',
  'fieldTypes.stock.description': 'Atualiza automaticamente o controle de estoque.',
  'fieldTypes.select.description': 'Permite escolher apenas uma opção da lista pré-definida. *Contém lógica',
  'fieldTypes.sign.description': 'Campo para assinatura digital pelo usuário.',
  'fieldTypes.signature.description': 'Assinatura armazenada no perfil do usuário (desenhar e salvar em PNG).',
  'fieldTypes.address.description': 'Campo para preenchimento de endereço completo.',
  'fieldTypes.location.description': 'Captura localização via Google Maps com geolocalização.',
  'fieldTypes.numeric.description': 'Campo exclusivo para números inteiros. *Contém lógica',
  'fieldTypes.float.description': 'Aceita números com ou sem vírgula. *Contém lógica',
  'fieldTypes.text.description': 'Campo livre para inserir informações textuais.',
  'fieldTypes.place.description': 'Selecione locais cadastrados previamente na plataforma. *Contém lógica',
  'fieldTypes.tags.description': 'Campo para classificação com etiquetas.',
  'fieldTypes.informative.description': 'Mostra instruções ou avisos sem interação do usuário.',
  'fieldTypes.user.description': 'Selecione usuários cadastrados previamente na plataforma.',
  'fieldTypes.calc.description': 'Executa cálculos automáticos numéricos através de fórmula. *Contém lógica',
  'fieldTypes.integration.description': 'Acione nosso time técnico para trazer informações externas.',
  'fieldTypes.cpf_cnpj.description': 'Inserção e validação automática de CPF ou CNPJ.',
  'fieldTypes.coordinates.description': 'Captura a sua localização atual no momento da resposta.',
  'fieldTypes.validation_code.description': 'Campo para inserir um código validado contra a atividade.',

  'fieldTypes.cCodCateg': 'Categoria',
  'fieldTypes.nCodCC': 'Cód. Conta Corrente',
  'fieldTypes.nQtdeParc': 'Quantidade de Parcelas',
  'fieldTypes.cCodServMun': 'Cód. Serviço ou CNAE',
  'fieldTypes.cCodServLC116': 'Cód. Serviço LC 116',
  'fieldTypes.cTribServ': 'Tributação dos Serviços',
  'fieldTypes.codVend': 'Vendedores',
  'fieldTypes.projects': 'Projetos',
  'fieldTypes.documentType': 'Tipo de documento',

  // Conditions
  'conditions.operators.eq': 'Igual a',
  'conditions.operators.neq': 'Diferente de',
  'conditions.operators.gt': 'Maior que',
  'conditions.operators.gte': 'Maior ou igual a',
  'conditions.operators.lt': 'Menor que',
  'conditions.operators.lte': 'Menor ou igual a',
  'conditions.operators.btwn': 'Entre',
  'conditions.operators.nbtwn': 'Não está entre',
  'conditions.operators.in': 'Um dos',
  'conditions.operators.any': 'Um dos',
  'conditions.operators.nany': 'Não contém',
  'conditions.operators.exactly': 'É exatamente',
  'conditions.operators.some': 'Um dos',
  'conditions.operators.all': 'Todos',
  'conditions.operators.every': 'Todos',
  'conditions.operators.within_ids': '',
  'conditions.operators.within_refs': '',
  'conditions.emptyUser': 'vazio',

  // Places
  place: 'Local',
  place_person: 'Pessoa',

  // Date
  createdAt: 'Criado em',
  'pdf.repliedAt': 'Respondido em {{date}}',
  updatedAt: 'Atualizado em',
  removedBy: 'Removido por',

  // Views
  'views.list': 'Visão de lista',
  'views.calendar': 'Visão de calendario',
  'views.listReplies': 'Visão de lista de respostas',
  'views.graphics': 'Visão de gráficos',
  newKanban: 'Novo Kanban',

  // Widgets
  'widgets.considering': 'Considerando: ',
  'widgets.allTime': 'De todos os tempos',
  'widgets.perspective': 'Perspectiva',
  'widgets.byHour': 'Por hora',
  'widgets.byDay': 'Por dia',
  'widgets.byMonth': 'Por mês',
  'widgets.byYear': 'Por ano',
  'widgets.activities': 'Atividades',
  'widgets.forms': 'Formulários',
  'widgets.presentation': 'Apresentação',
  'widgets.color': 'Cor',
  'widgets.filters': 'Filtros',
  'widgets.ignorePeriod': 'Ignorar periodo?',
  'widgets.counterOnly': 'Somente contador',
  'widgets.percentageBar': 'Barra de porcentagem',
  'widgets.circularPercentage': 'Procentagem circular',
  'widgets.lines': 'Linhas',
  'widgets.bars': 'Barras',
  'widgets.initialPerspective': 'Perspectiva inicial',
  'widgets.hidePerspectiveSelection': 'Esconder seleção de perspectiva?',
  'widgets.name': 'Nome',
  'widgets.completed': 'Concluídas',
  'widgets.open': 'Abertas',
  'widgets.pending': 'Pendentes',
  'widgets.compliancesCounter.name': 'Porcentagem de não conformidades',
  'widgets.compliancesCounter.description': 'Lorem Ipsum',
  'widgets.compliancesCounter.category': 'Conformidade',
  'widgets.serviceOrdersCounter.name': 'Contagem de atividades',
  'widgets.serviceOrdersCounter.description': 'Lorem Ipsum',
  'widgets.serviceOrdersCounter.category': 'Atividades',
  'widgets.serviceOrdersCounter.initialStateName': 'Atividades',
  'widgets.noPreview': 'Esse widget não possui pré visualização',
  'widgets.nonCompliancesCounter.name': 'Contagem de não conformidades',
  'widgets.nonCompliancesCounter.description': 'Lorem Ipsum',
  'widgets.nonCompliancesCounter.category': 'Conformidade',
  'widgets.nonCompliancesCounter.initialStateName': 'Não conformidades',
  'widgets.usersCounter.name': 'Contagem de usuários',
  'widgets.usersCounter.description': 'Lorem Ipsum',
  'widgets.usersCounter.category': 'Usuários',
  'widgets.usersCounter.initialStateName': 'Usuários',
  'widgets.placesCounter.name': 'Contagem de locais',
  'widgets.placesCounter.description': 'Lorem Ipsum',
  'widgets.placesCounter.category': 'Locais',
  'widgets.placesCounter.initialStateName': 'Locais',
  'widgets.formsCounter.name': 'Contagem de formulários',
  'widgets.formsCounter.description': 'Lorem Ipsum',
  'widgets.formsCounter.category': 'Formulários',
  'widgets.formsCounter.initialStateName': 'Formulários',
  'widgets.formRepliesCounter.name': 'Contagem de respostas de formulários',
  'widgets.formRepliesCounter.description': 'Lorem Ipsum',
  'widgets.formRepliesCounter.category': 'Formulários',
  'widgets.formRepliesCounter.initialStateName': 'Respostas de formulários',
  'widgets.groupedEventsByReason.name': 'Eventos agrupado por motivo',
  'widgets.groupedEventsByReason.description': 'Lorem Ipsum',
  'widgets.groupedEventsByReason.category': 'Atividades',
  'widgets.averageEventsAmountByPeriod.name': 'Quantidade de atividades médias executadas por periodo',
  'widgets.averageEventsAmountByPeriod.description': 'Lorem Ipsum',
  'widgets.averageEventsAmountByPeriod.category': 'Atividades',
  'widgets.averageFormRepliesAmountByPeriod.name': 'Respostas de formulários médios por periodo',
  'widgets.averageFormRepliesAmountByPeriod.description': 'Lorem Ipsum',
  'widgets.averageFormRepliesAmountByPeriod.category': 'Formulários',
  'widgets.periodicFormReplies.name': 'Volume de respostas de formulários por periodo',
  'widgets.periodicFormReplies.description': 'Lorem Ipsum',
  'widgets.periodicFormReplies.category': 'Formulários',
  'widgets.periodicServiceOrdersByStatus.name': 'Volume de atividades por status',
  'widgets.periodicServiceOrdersByStatus.description': 'Lorem Ipsum',
  'widgets.periodicServiceOrdersByStatus.category': 'Atividades',
  'widgets.periodicNonCompliances.name': 'Volume de não conformidades por periodo',
  'widgets.periodicNonCompliances.description': 'Lorem Ipsum',
  'widgets.periodicNonCompliances.category': 'Conformidade',
  'widgets.groupedNonCompliances.name': 'Não conformidades por entidade',
  'widgets.groupedNonCompliances.description': 'Lorem Ipsum',
  'widgets.groupedNonCompliances.category': 'Conformidade',
  'widgets.ranking.name': 'Ranking',
  'widgets.ranking.description': 'Lorem Ipsum',
  'widgets.usersRanking.name': 'Ranking de usuários',
  'widgets.usersRanking.category': 'Usuários',
  'widgets.placesRanking.name': 'Ranking de locais',
  'widgets.placesRanking.category': 'Locais',
  'widgets.checklistsRanking.name': 'Ranking de questionários',
  'widgets.checklistsRanking.category': 'Questionários',
  'widgets.embed.name': 'Conteúdo embedado',
  'widgets.embed.description': 'Esse widget permite embedar conteúdos de dentro e fora da Btime.',
  'widgets.embed.category': 'Embed',
  'widgets.embed.initialStateName': 'Conteúdo embedado',
  'widgets.status': 'Status',
  'widgets.all': 'Todas',
  'widgets.done': 'Concluídas',
  'widgets.type': 'Tipo',
  'widgets.groupedBy': 'Agrupado por',
  'widgets.evaluatedCompliances': 'Conformidades avaliadas',
  'widgets.nonCompliances': 'Não conformidades',
  'widgets.canceled': 'Canceladas',
  'widgets.questionnaire': 'Questionário',
  'widgets.locals': 'Locais',
  'widgets.user': 'Usuário',
  'widgets.invertPerspective': 'Inverter perspectiva?',
  'widgets.period': 'Periodo',
  'widgets.timeOfDay': 'Horário do dia',
  'widgets.dayOfWeek': 'Dia da semana',
  'widgets.barColor': 'Cor das barras',
  'widgets.url': 'URL*',
  'widgets.rejected': 'Reprovadas',
  'widgets.approved': 'Aprovadas',
  'widgets.openings': 'Aberturas',
  'widgets.completions': 'Conclusões',
  'widgets.discontinuations': 'Descontinuções',
  'widgets.total': 'Total',
  'widgets.removeScreenItem.confirm': 'Certeza que deseja remover?',
  'widgets.removeScreenItem.success': 'Tela removida com sucesso!',
  'widgets.removeScreenItem.error': 'Ocorreu um erro ao remover!',

  'serviceOrders.removeModal.title': 'As seguintes atividades serão removidas',
  'serviceOrders.removeModal.description': 'Ao remover uma atividade suas filhas também serão removidas',
  'serviceOrders.removeActivities': 'Remover atividades',
  removeInitialValue: 'Remover valor inicial',

  'routines.confirmRemove': 'Tem certeza que deseja remover a rotina {{name}}?',
  'routines.removeError': 'Ocorreu um erro ao remover rotina!',

  // Filters and lists
  betaVersionMessage: 'Você está vendo a versão beta',
  useOldVersion: 'Usar versão antiga',

  itemsFound: '{{count}} item encontrado',
  itemsFound_plural: '{{count}} itens encontrados',

  emptyMessage: 'Nenhum dado encontrado!',
  errorMessage: 'Ocorreu um erro ao conectar com o servidor!',

  // Device info
  deviceModel: 'Modelo',
  battery: 'Bateria',
  application: 'Aplicativo',
  storage: 'Armazenamento',

  cleanDate: 'Limpar data',
  selectInitDate: 'Selecione a data de início',
  selectEndDate: 'Selecione a data de fim',

  showAll: 'Mostrar tudo',
  showOnly: 'Mostrar somente',
  clean: 'Limpar',
  applyFilters: 'Aplicar Filtros',
  filterBy: 'Filtrar por',
  sortBy: 'Ordenar por',
  ASC: 'Crescente',
  DESC: 'Descrescente',
  cleanFilters: 'Limpar filtros',
  filter: 'Filtrar',
  sort: 'Ordenar',
  search: 'Pesquisar',
  selectAll: 'Selecionar todos',
  selected: 'Selecionado',
  select: 'Selecionar',
  selected_plural: 'Selecionados',

  //Non Compliance
  openActionPlan: 'Abrir plano de ação',
  lastReplies: 'Últimas respostas',
  ignoreNonCompliance: 'Ignorar',
  removeIgnoreNonCompliance: 'Não ignorar',
  completeNonCompliance: 'Marcar como concluída',
  markAsCompleted: 'Marcar como concluída',
  createActionPlan: 'Criar Plano de Ação',
  'option.replies': 'Respostas',
  'option.serviceOrders': 'Ordens de Serviço',

  // General
  metrics: 'Métricas',
  rest: 'Outros',
  pay: 'Pagar',
  files: 'Arquivos',
  clone: 'Clonar',
  export: 'Exportar',
  reply: 'Responder',
  details: 'Detalhes',
  questions: 'Perguntas',
  simulation: 'Simulação',
  noUser: 'Sem usuário',
  noPlace: 'Sem local',
  changeUser: 'Alterar usuário',
  changePassword: 'Alterar senha',
  execute: 'Executar',
  executeInBulk: 'Executar em massa',
  reopen: 'Reabrir',
  resume: 'Resumo',
  logs: 'Logs',
  generateCustomDocument: 'Gerar Documento Personalizado',
  sendPublicLink: 'Enviar link público',
  sendPublicLinks: 'Enviar links público',
  generateQRCode: 'Gerar QR Code',
  generateQRCodes: 'Gerar QR Codes',
  createActivities: 'Criar atividades',
  saveAsTemplate: 'Salvar como template',
  recoverUser: 'Recuperar usuário',
  reinstall: 'Reinstalar',
  registerTechnician: 'Cadastrar Técnico',
  viewTechnicians: 'Visualizar Técnicos',
  sendFormFull: 'Enviar formulário',
  public: 'Público',
  private: 'Privado',
  replies: '{{count}} resposta',
  replies_plural: '{{count}} respostas',
  close: 'Fechar',
  branch: 'Filial',
  headquarter: 'Matriz',
  sendQrCodes: 'Enviar QrCodes',
  minimum: 'Min: {{count}}',
  maximum: 'Max: {{count}}',
  tryAgain: 'Tentar novamente',
  print: 'Imprimir',

  create: 'Criar',
  update: 'Atualizar',
  sendForm: 'Enviar form.',
  send: 'Enviar',
  begin: 'Iniciar',
  person: 'Pessoa',
  location: 'Local',
  types: 'Tipos',
  share: 'Compartilhar',
  assets: 'Ativos',
  field: 'Campo',
  fields: 'Campos',
  seeDetails: 'Ver detalhes',
  remove: 'Remover',
  docGenerate: 'Gerar PDF',
  actions: 'Ações',
  moreOptions: 'Mais Opções',
  addPhoto: 'Adicionar Foto',
  yes: 'Sim',
  no: 'Não',
  active: 'Ativo',
  inactive: 'Inativo',
  notAvailable: 'N/A',
  fieldInDevelopment: 'Campo em desenvolvimento',
  required: 'Obrigatório',
  pause: 'Pausar',
  saveAndPause: 'Salvar e pausar',
  submit: 'Enviar',
  edit: 'Editar',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  save: 'Salvar',

  // Question types
  'questions.types.checkbox': 'Checkbox',
  'questions.types.compliance': 'Conformidade',
  'questions.types.text': 'Texto',
  'questions.types.gallery': 'Anexos',
  'questions.types.number': 'Númerico',
  'questions.types.sign': 'Assinatura',

  // Question answers
  'questions.answers.yes': 'Sim',
  'questions.answers.no': 'Não',

  // Status
  changeStatus: 'Alterar Status',
  approval: 'Aprovação',
  approve: 'Aprovar',
  disapprove: 'Reprovar',
  'status.reason.approved': 'Motivo da aprovação',
  'status.reason.canceled': 'Motivo do cancelamento',
  'status.reason.unproductive': 'Motivo do improdutividade',
  'status.reason.refused': 'Motivo de ter recusado',
  'status.reason.disapproved': 'Motivo da reprovação',
  'status.reason.closing': 'Motivo de encerramento',
  'status.action.approved': 'Aprovar',
  'status.action.disapproved': 'Reprovar',
  'status.action.canceled': 'Cancelar',
  'status.pastAction.request': 'Abriu solicitação',
  'status.pastAction.open': 'abriu',
  'status.pastAction.received': 'recebeu',
  'status.pastAction.accept': 'aceitou',
  'status.pastAction.refused': 'recusou',
  'status.pastAction.execution': 'executou',
  'status.pastAction.pause': 'pausou',
  'status.pastAction.unproductive': 'marcou como improdutiva',
  'status.pastAction.completed': 'concluiu',
  'status.pastAction.pending': 'deixou pendente',
  'status.pastAction.canceled': 'cancelou',
  'status.pastAction.approved': 'aprovou',
  'status.pastAction.disapproved': 'reprovou',
  'status.pastAction.resolved': 'resolvel',
  'status.pastAction.unresolved': 'marcou como não resolvida',
  'status.pastAction.actionPlan': 'criou plano de ação',
  'status.pastAction.closing': 'encerrou',
  'status.all': 'Todas',
  'status.request': 'Solicitação',
  'status.open': 'Aberta',
  'status.received': 'Recebida',
  'status.accept': 'Aceita',
  'status.refused': 'Recusada',
  'status.execution': 'Execução',
  'status.pause': 'Pausada',
  'status.unproductive': 'Improdutiva',
  'status.completed': 'Concluída',
  'status.pending': 'Pendente',
  'status.canceled': 'Cancelada',
  'status.approved': 'Aprovada',
  'status.disapproved': 'Reprovada',
  'status.resolved': 'Resolvida',
  'status.unresolved': 'Não Resolvida',
  'status.actionPlan': 'Plano de Ação',
  'status.request_plural': 'Solicitações',
  'status.open_plural': 'Abertas',
  'status.received_plural': 'Recebidas',
  'status.accept_plural': 'Aceitas',
  'status.refused_plural': 'Recusadas',
  'status.execution_plural': 'Execuções',
  'status.pause_plural': 'Pausadas',
  'status.unproductive_plural': 'Improdutivas',
  'status.completed_plural': 'Concluídas',
  'status.pending_plural': 'Pendentes',
  'status.canceled_plural': 'Canceladas',
  'status.approved_plural': 'Aprovadas',
  'status.disapproved_plural': 'Reprovadas',
  'status.resolved_plural': 'Resolvidas',
  'status.unresolved_plural': 'Não Resolvidas',
  'status.actionPlan_plural': 'Planos de Ação',
  'status.done': 'Concluídas',
  'status.ignored': 'Ignorada',
  'status.ignored_plural': 'Ignoradas',
  'status.closing': 'Encerramento',
  'status.closing_plural': 'Encerramentos',

  'status.inProgress': 'Em andamento',
  'status.inProgress_plural': 'Em andamento',

  'priority.critical': 'Crítica',
  'priority.high': 'Alta',
  'priority.medium': 'Média',
  'priority.low': 'Baixa',

  // Actions
  complete: 'Concluir',
  generatePDFSummary: 'Gerar Resumo em PDF',
  createChildActivity: 'Criar filha',

  'month.1': 'Jan',
  'month.2': 'Fev',
  'month.3': 'Mar',
  'month.4': 'Abr',
  'month.5': 'Mai',
  'month.6': 'Jun',
  'month.7': 'Jul',
  'month.8': 'Ago',
  'month.9': 'Set',
  'month.10': 'Out',
  'month.11': 'Nov',
  'month.12': 'Dez',

  'counter.text': 'Registros encontrados',
  requeue_failed_tasks: 'Reexecutar tarefas falhadas',
  retry_failed_confirm: 'Tem certeza que deseja reexecutar as tarefas falhadas?',

  // Errors
  error: 'Erro',
  'errors.duplicateRecord': 'Não é possível adicionar registros duplicados!',
  'errors.cannotRemoveHasUsers': 'Não foi possível remover. Há pelo menos um usuário com este item.',
  insufficientAmount: 'Quantidade insuficiente',
  valueMustBeGreaterThanZero: 'Quantidade deve ser maior que zero',
  'assets.generateQrCode': 'Gerar QR Code',
  'assets.generateQrCodes': 'Gerar QR Codes',
  'processes.remove.success': 'Processo removido com sucesso!',
  'screens.remove.success': 'Tela removida com sucesso!',
  'screenViews.remove.success': 'Visão removida com sucesso!',
  'errors.remove': 'Ocorreu um erro ao remover!',

  // ModalPicker
  selectOneOrMore: 'Selecione um ou mais:',
  include: 'Incluir',
  disabled: 'Desativados',
  deleted: 'Removidos',

  // IconPicker
  selectOne: 'Selecione um',
  icon: 'ícone',
  removeSelection: 'Remover seleção',

  // LevelSection
  levelConfiguration: 'Configuração de Nível',
  selectLevelToApplyConfiguration: 'Selecione um nível para aplicar essa configuração apenas aos níveis selecionados.',
  type: 'Tipo',
  level: 'Nível',

  // Common actions
  confirmRemove: 'Tem certeza que deseja remover?',
  clearSelection: 'Limpar seleção',
  errorDelete: 'Ocorreu um erro ao deletar!',
  removeSuccess: 'Removido com sucesso!',

  // Common entities
  activities: 'Atividades',
  user: 'Usuário',
  users: 'Usuários',
  group: 'Grupo',
  status: 'Status',
  tag: 'Tag',
  selectStatus: 'Seleção de status',
  automatic: 'Automático',
  asset: 'Ativo',
  views: 'Visões',
  places: 'Locais',
  people: 'Pessoas',
  fleets: 'Frotas',
  creationDate: 'Data de criação',
  schedulingDate: 'Data de agendamento',
  completionDate: 'Data de conclusão',
  dates: '{{count}} datas',
  opening: 'Abertura',
  sla: 'SLA',
  overdue: 'Em Atraso',
  id: 'ID',
  showDeleted: 'Mostrar removidos',
  documentsCount: '{{count}} documento(s)',
  actionPlansCount: '{{count}} plano(s) de ação',
  'config.service_order_started_since_colors.normal': 'Normal',
  'config.service_order_started_since_colors.warning': 'Aviso',
  'config.service_order_started_since_colors.critic': 'Crítico',

  // Date Picker
  'datePicker.selectDate': 'Seleção de data',
  'datePicker.suggestions': 'Sugestões',
  'datePicker.today': 'Hoje',
  'datePicker.yesterday': 'Ontem',
  'datePicker.currentWeek': 'Semana atual',
  'datePicker.lastWeek': 'Semana passada',
  'datePicker.currentMonth': 'Mês atual',
  'datePicker.lastMonth': 'Mês passado',
  'datePicker.currentQuarter': 'Trimestre atual',
  'datePicker.lastQuarter': 'Trimestre passado',
  'datePicker.currentYear': 'Ano atual',
  'datePicker.lastYear': 'Ano passado',
  'datePicker.last3Years': 'Últimos 3 anos',
  'datePicker.last5Years': 'Últimos 5 anos',
  'datePicker.next7Days': 'Próximos 7 dias',
  reopenActivity: 'Reabrir Atividade',
  finish: 'Finalizar',

  // Modals
  'modals.editingUser': 'Editando usuário',
  'modals.creatingUser': 'Criando usuário',
  'modals.changingPassword': 'Alterando senha',
  'modals.editingUsers': 'Editando usuários',
  'modals.registeringUsers': 'Cadastrando usuários',
  'modals.editGroup': 'Editar Grupo',
  'modals.createGroup': 'Criar Grupo',
  'modals.editChecklistCategory': 'Editar Categoria do Questionário',
  'modals.createChecklistCategory': 'Criar Categoria do Questionário',
  'modals.editMinicrud': 'Editar',
  'modals.createMinicrud': 'Criar',
  'modals.editingPlace': 'Editando local',
  'modals.creatingPlace': 'Criando local',
  'modals.customizeLevels': 'Customizar níveis',
  'modals.editingPlaceLevel': 'Editando nível de locais',
  'modals.creatingPlaceLevel': 'Criando nível de locais',
  'modals.editingTag': 'Editando tag',
  'modals.creatingTag': 'Criando tag',
  'modals.tagsList': 'Tags de Atividade',
  'modals.editingPlaceType': 'Editando Tipo de locais',
  'modals.creatingPlaceType': 'Criando Tipo de locais',
  'modals.registeringItems': 'Cadastrando Itens',
  'modals.editingProfile': 'Editando perfil',
  'modals.creatingProfile': 'Criando perfil',
  'modals.cloningProcess': 'Clonando processo',
  'modals.editingProcess': 'Editando processo',
  'modals.creatingProcess': 'Criando processo',
  'modals.cloningScreen': 'Clonando tela',
  'modals.editingScreen': 'Editando tela',
  'modals.creatingScreen': 'Criando tela',
  'modals.cloningColumn': 'Clonando coluna',
  'modals.editingColumn': 'Editando coluna',
  'modals.creatingColumn': 'Criando coluna',
  'modals.editingWidget': 'Editando widget',
  'modals.addingWidget': 'Adicionando widget',
  'modals.editingServiceOrderUser': 'Editando Usuário Responsável',
  'modals.editingStatus': 'Editando Status',
  'modals.exportingServiceOrders': 'Exportando atividade(s)',
  'modals.replyingServiceOrder': 'Respondendo atividade',
  'modals.serviceOrderResume': 'Resumo da atividade',
  'modals.cloningServiceOrder': 'Clonando atividade',
  'modals.editingServiceOrder': 'Editando atividade',
  'modals.creatingServiceOrder': 'Criando atividade',
  'modals.editingServiceOrders': 'Editando atividades',
  'modals.registeringServiceOrders': 'Cadastrando atividades',
  'modals.sendingPublicExecutionLink': 'Enviando link público de execução',
  'modals.replies': 'Respostas',
  'modals.editingDynamicServiceOrders': 'Editando Atividades Dinâmicas',
  'modals.creatingDynamicServiceOrders': 'Criando Atividades Dinâmicas',
  'modals.editingStockItem': 'Editando item',
  'modals.creatingStockItem': 'Criando item',
  'modals.details': 'Detalhes',
  'modals.transfers': 'Transferências',
  'modals.transferHistory': 'Histórico de transferências',
  'modals.formEdit': 'Edição de Formulário',
  'modals.formsEdit': 'Edição de Formulários',
  'modals.formReply': 'Resposta do Formulário',
  'modals.actionPlans': 'Planos de ação',
  'modals.editingAsset': 'Editando Item',
  'modals.creatingAsset': 'Cadastrando Item',
  'modals.templatesList': 'Listagem de Templates',
  'modals.editingTemplate': 'Editando template',
  'modals.creatingTemplate': 'Criando template',
  'modals.templateDetails': 'Detalhes de Template',
  'modals.documentGeneration': 'Geração de Documento',
  'modals.documentsHistory': 'Histórico de Documentos',
  'modals.cloningChecklist': 'Clonando questionário',
  'modals.chooseTemplate': 'Escolha um template',
  'modals.automations': 'Automações',
  'modals.templates': 'Templates',
  'modals.automationDetails': 'Detalhes da Automação',
  'modals.editingAutomation': 'Editando automação',
  'modals.creatingAutomation': 'Criando automação',
  'modals.triggerFired': 'Gatilho disparado',
  'modals.qrCodeMenus': 'Menus de QR Code',
  'modals.editingLinktree': 'Editando Linktree',
  'modals.creatingLinktree': 'Criando Linktree',
  'modals.publicLinks': 'Links Públicos',
  'modals.editPublicToken': 'Editar token Público',
  'modals.newPublicToken': 'Novo token Público',
  'modals.publicToken': 'Token Público',
  'modals.newIntegration': 'Nova integração',
  'modals.newAccount': 'Nova conta',
  'modals.editingWebhook': 'Editando webhook',
  'modals.creatingWebhook': 'Criando webhook',
  'modals.newConfiguration': 'Nova configuração',
  'modals.webhookDetails': 'Detalhes webhook',
  'modals.routines': 'Rotinas',
  'modals.editingRoutine': 'Editando rotina',
  'modals.creatingRoutine': 'Criando rotina',
  'modals.editingPermissions': 'Editando permissões',
  'modals.nonCompliance': 'Não conformidade',
  'modals.nonComplianceBulkEdit': 'Edição em massa de não conformidade',
  'modals.actionPlan': 'Plano de Ação',
  'modals.imports': 'Importações',
  'modals.export': 'Exportação',
  'modals.exports': 'Exportações',
  'modals.buckets': 'Lotes',
  'modals.newBucket': 'Novo lote',
  'modals.editingView': 'Editando visão',
  'modals.editingFields': 'Editando campos adicionais',
  'modals.createStrongPassword': 'Criar uma senha forte',
  'modals.alert': 'Alerta',
  'modals.formInvites': 'Envio de convites',
  'modals.semaphoreConfig': 'Configuração de semaforo',
  'modals.availabilityStatusSourceConfig': 'Origem do Status de Disponibilidade',
  'modals.automaticDistribution': 'Distribuição automática',
  'modals.survey': 'Pesquisa',
  'modals.generatingQrCode': 'Gerando QR Code',
  'modals.generatingQrCodes': 'Gerando QR Codes',
  'modals.groupedItems': 'Itens agrupados',
  'modals.newTechnician': 'Novo tecnico',
  'modals.registeredTechnicians': 'Técnicos Cadastrados'
}
